// Static imports
import UserMain from '@/views/member/user'
import UserCreate from '@/views/member/user/pages/userCreate'
import UserList from '@/views/member/user/pages/list'
import UserList2 from '@/views/member/user/pages/list2'
import UserDetail from '@/demo/MemberDetail.vue'
import UserSignUpList from '@/views/member/user/pages/signUpList'
import UserPayment from '@/views/member/user/pages/userpayment'
import CashList from '@/views/member/user/pages/cashList'
import CashChangeHistory from '@/views/member/user/pages/cashChangeHistory'
import PointList from '@/views/member/user/pages/pointList'
import PointListNew from '@/views/member/user/pages/pointListNew'
import UserTracking from '@/views/member/user/pages/userTracking'
import UserBlock from '@/views/member/user/pages/userBlock'
import LoginList from '@/views/member/user/pages/loginList'
import UserGameRolling from '@/views/member/user/pages/userGameRolling'
import MultiUsers from '@/views/member/user/pages/multiUsers'
import CashHistory from '@/views/member/user/pages/cashHistory'
import CashMoveHistory from '@/views/member/user/pages/cashMoveHistory'
import RateSettings from '@/views/member/company/pages/rateSettings'
import RateSettingsToggle from '@/views/member/company/pages/rateSettingsToggle'

export default {
  name: 'user',
  path: '/user',
  component: UserMain,
  redirect: {
    name: 'userList'
  },
  props: true,
  meta: {
    layout: 'default',
    isActive: false,
    text: '회원관리',
    icon: 'icon_user',
    code: 'LV010000'
  },
  children: [
    {
      name: 'userCreate',
      path: '/user/Create',
      component: UserCreate,
      meta: {
        menuMember: true,
        text: '회원 생성',
        done: true,
        code: 'LV010100'
      }
    },
    {
      name: 'userCreateView',
      path: '/user/CreateView',
      component: UserCreate,
      meta: {
        layout: 'popup',
        menuMember: true,
        text: '회원 생성',
        done: true
      }
    },
    {
      name: 'userList',
      path: '/user/list',
      component: UserList,
      meta: {
        menuMember: true,
        text: '회원리스트',
        done: true,
        code: 'LV010200'
      }
    },
    {
      name: 'userList2',
      path: '/user/list2',
      component: UserList2,
      meta: {
        menuMember: true,
        text: '파트너별 회원리스트',
        done: true,
        code: 'LV010600'
      }
    },
    {
      name: 'userDetail',
      path: '/user/detail',
      component: UserDetail,
      meta: {
        menuMember: true,
        text: '회원 관리',
        done: true,
        code: 'LV011200'
      }
    },
    {
      name: 'userDetailView',
      path: '/user/detailView',
      component: UserDetail,
      meta: {
        layout: 'popup',
        menuMember: true,
        text: '회원 관리',
        done: true
      }
    },
    {
      name: 'userSignUpList',
      path: '/user/signUpList',
      props: true,
      component: UserSignUpList,
      meta: {
        menuMember: true,
        text: '회원가입승인',
        done: true,
        code: 'LV010300'
      }
    },
    {
      name: 'userpayment',
      path: '/user/userpayment',
      component: UserPayment,
      meta: {
        menuMember: true,
        text: '일괄 지급',
        done: true
      }
    },
    // {
    //   name: "userCallApply",
    //   path: "/user/userCallApply",
    //   component: () => import("@/views/member/user/pages/userCallList"),
    //   meta: {
    //     menuMember: true,
    //     text: "전화요청"
    //   }
    // },
    {
      name: 'UserCashReports',
      path: '/user/cash/report',
      component: CashList,
      meta: {
        menuMember: true,
        text: '회원 입출금'
        // code: 'LV010400'
      }
    },
    {
      name: 'UserCashChangeHistory',
      path: '/user/cash/change_history',
      component: CashChangeHistory,
      meta: {
        menuMember: true,
        text: '캐시이동내역',
        code: 'LV010500'
      }
    },
    // {
    //   name: "userRolling",
    //   path: "/user/rolling",
    //   component: () => import("@/views/member/user/pages/rolling"),
    //   meta: {
    //     menuMember: true,
    //     text: "롤링 관리"
    //   }
    // },
    {
      name: 'userPointList',
      path: '/user/pointList',
      component: PointList,
      meta: {
        menuMember: true,
        text: '포인트 관리',
        code: 'LV010700'
      }
    },
    {
      name: 'userPointListNew',
      path: '/user/pointListNew',
      component: PointListNew,
      meta: {
        menuMember: true,
        text: '포인트 관리',
        code: 'LV011300'
      }
    },
    {
      name: 'userTracking',
      path: '/user/userTracking',
      component: UserTracking,
      meta: {
        menuMember: true,
        text: '사용자추적',
        code: 'LV010800'
      }
    },
    {
      name: 'userBlock',
      path: '/user/userBlock',
      component: UserBlock,
      meta: {
        menuMember: true,
        text: 'IP차단 목록',
        code: ''
      }
    },
    {
      name: 'loginList',
      path: '/user/loginList',
      component: LoginList,
      meta: {
        menuMember: true,
        text: '로그인한 회원',
        code: 'LV010900'
      }
    },
    {
      name: 'userGameRolling',
      path: '/user/userGameRate',
      component: UserGameRolling,
      meta: {
        menuMember: true,
        text: '회원 롤링 요율관리',
        done: true,
        code: 'LV011000'
      }
    },
    {
      name: 'multiUserList',
      path: '/user/multiUsers',
      component: MultiUsers,
      meta: {
        menuMember: true,
        text: '멀티아이피 내역',
        code: 'LV011100'
      }
    },
    // {
    //   name: "supUserChange",
    //   path: "/user/supUserChange",
    //   component: () => import("@/views/member/user/pages/supUserChange"),
    //   meta: {
    //     menuMember: true,
    //     text: "상위유저변경"
    //   }
    // },
    // {
    //   name: "userDetail",
    //   path: "/user/detail",
    //   component: () => import("@/views/member/user/pages/detail"),
    //   meta: {
    //     menuMember: false,
    //     bodyClass: "popupBody"
    //   }
    // },
    {
      path: '/user/cashHistory',
      name: 'CashHistory',
      component: CashHistory,
      meta: {
        menuMember: false
      }
    },
    {
      path: '/user/cash/cashMoveHistory',
      name: 'CashMoveHistory',
      component: CashMoveHistory,
      meta: {
        menuMember: true,
        text: '캐시 변동 내역'
      }
    },
    {
      path: '/user/detail/rate/setting/:id',
      name: 'rateSettings',
      component: RateSettings,
      meta: {
        menuMember: false,
        bodyClass: 'popupBody'
      }
    },
    {
      path: '/user/detail/bet/toggle/:id',
      name: 'rateSettingsToggle',
      component: RateSettingsToggle,
      meta: {
        menuMember: false,
        bodyClass: 'popupBody'
      }
    }
  ]
}
